import styled from '../../../../../styles/theme';
import { StockModelCardDealerInfoStyledOV } from './StockModelCardDealerInfoStyled.OV';
import { rem } from 'polished';

export const StockModelCardDealerInfoStyledOVGB = styled(StockModelCardDealerInfoStyledOV)`
    .stockModelCard-dealerInfo--ctaSection {
        button {
            min-height: ${rem('48px')};
            font-size: ${rem('14px')};
            font-family: ${({ theme }) => theme.fonts.fontBase};
            color: ${({ theme }) => theme.colors.white};
            background: ${({ theme }) => theme.colors.primary};
            border: 2px solid ${({ theme }) => theme.colors.primary};
            font-weight: normal;
            text-transform: uppercase;

            &:hover {
                background: ${({ theme }) => theme.colors.white};
                color: ${({ theme }) => theme.colors.primary};
                border: 2px solid ${({ theme }) => theme.colors.primary};
            }
        }
    }
`;
